import React from 'react'
import PropTypes from 'prop-types'
import styles from './ItemLabel.icss'

class ItemLabel extends React.Component {
	render() {
		return (
			<div className={styles.itemLabel}>
				{this.props.children}
			</div>
		)
	}
}

ItemLabel.propTypes = {
	children: PropTypes.node.isRequired
}

export default ItemLabel



// WEBPACK FOOTER //
// ./src/components/ItemLabel.jsx